module.exports = __webpack_public_path__ + "media/Slide1.64f3bc80.mp3";